import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { ADMIN_USER_TYPE_ID, ERROR_KEY, MERCHANT_USER_TYPE_ID } from "../../Constants/MainKeys";
import { setSiteTourIsNotified } from "../../store/intro/actions";
import ApiService from "../../Services/ApiService";
import AlertService from "../../Services/alertService";
import { setOrganizationData } from "../../store/main/actions";

const AccountStatusIndicator = ({ isActive }) => {
  const statusConfig = {
    verified: {
      color: "#34c38f",
      label: "Verified account",
      tooltip: "Verified account"
    },
    unverified: {
      color: "#f46a6a",
      label: "Unverified account",
      tooltip: "Current organization has not been approved by the Cryllex administration."
    }
  };

  const status = isActive ? statusConfig.verified : statusConfig.unverified;

  return (
    <div className="h-100 d-flex align-items-center mx-3">
      <OverlayTrigger
        placement="bottom"
        overlay={(props) => <Tooltip {...props}>{status.tooltip}</Tooltip>}
      >
        <div className="d-flex align-items-center">
          <div
            className="me-1"
            style={{
              backgroundColor: status.color,
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              marginBottom: "2px",
            }}
          />
          <span className="ms-1 mb-0 text-nowrap fw-500 d-none d-lg-block">
            {status.label}
          </span>
        </div>
      </OverlayTrigger>
    </div>
  );
};

const Header = () => {
  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.Languages);
  const { stepsData } = useSelector((state) => state.Intro);
  const { user } = useSelector((state) => state.Login);
  const { organizationData } = useSelector((state) => state.Main);


  const tToggle = () => {
    document.body.classList.toggle("vertical-collpsed");
    document.body.classList.toggle("sidebar-enable");
  };

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
  }

  useEffect(() => {
    const getOrganizationData = () => {
      ApiService.getOrganizationData().then(response => {
        if (response && response.data) {
          dispatch(setOrganizationData(response.data));
        }
      }).catch(error => getFail(error)).finally(() => { })
    }

    if (user && user.userTypeId === MERCHANT_USER_TYPE_ID) {
      getOrganizationData()
    }
    return () => {
      dispatch(setOrganizationData(null));
    }
  }, [user])

  useEffect(() => {
    if (organizationData && organizationData.legalBusinessName) {
      document.body.classList.add('has-organization-data');
    } else {
      document.body.classList.remove('has-organization-data');
    }
    return () => {
      document.body.classList.remove('has-organization-data');
    }
  }, [organizationData])


  return (
    <header id="page-topbar">
      <div className="navbar-header">
        <div className="d-flex align-items-center">
          <button
            type="button"
            onClick={tToggle}
            className="btn btn-sm px-3 font-size-16 header-item"
            id="vertical-menu-btn"
          >
            <i className="fa fa-fw fa-bars" />
          </button>

          <div className="h-100 d-flex align-items-center">
            <h4 className="mb-0 text-nowrap d-none d-lg-block">{moment(new Date()).format("LL")}</h4>
            <h4 className="mb-0 text-nowrap d-block d-lg-none">{moment(new Date()).format("ll")}</h4>
          </div>

          {user?.userTypeId === MERCHANT_USER_TYPE_ID && (
            <AccountStatusIndicator isActive={user.isActive} />
          )}
        </div>

        <div className="d-flex align-items-center">
          <LanguageDropdown />

          {user?.userTypeId === MERCHANT_USER_TYPE_ID && (
            <button
              title="Download PDF"
              type="button"
              className="btn header-item noti-icon"
            >
              <i className="bx bx-download"></i>
            </button>
          )}

          <div className="dropdown d-none d-lg-inline-block">
            {stepsData?.data && JSON.parse(stepsData.data).length > 0 && (
              <button
                type="button"
                className="btn header-item noti-icon"
                onClick={() => dispatch(setSiteTourIsNotified(false))}
              >
                <i className="bx bx-directions"></i>
              </button>
            )}

            {user?.userTypeId !== ADMIN_USER_TYPE_ID && (
              <Link to={`/${language}/customer-support`}>
                <button type="button" className="btn header-item noti-icon">
                  <i className="bx bx-support"></i>
                </button>
              </Link>
            )}
          </div>

          <NotificationDropdown />
          <ProfileMenu />
        </div>
      </div>
      {
        organizationData && organizationData.legalBusinessName && (
          <div style={{ background: "#fff" }}>
            <hr className="my-0" />
            <div
              className="d-flex align-items-center gap-2 text-nowrap overflow-auto"
              style={{
                padding: "8px 20px",
                borderRadius: "0 0 10px 10px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                borderTop: "1px solid #f3f3f3",
              }}
            >
              <span className="text-muted text-nowrap" style={{ fontSize: "13px" }}>
                Legal Business Name:
              </span>
              <span
                className="fw-bold text-dark"
                style={{
                  fontSize: "14px",
                  background: "#f5f6fc",
                  borderRadius: "6px",
                  padding: "2px 10px",
                  letterSpacing: "0.01em"
                }}
              >
                {organizationData.legalBusinessName}
              </span>
            </div>
          </div>
        )
      }
    </header>
  );
};

export default Header;
